import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TvOffOutlined } from '@material-ui/icons';
import React, { FC, ReactElement } from 'react';
import { isNull, isUndefined } from 'util';
import { ViewState } from '../../../domain/models/ViewState';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%'
  },
  errorIcon: {
    fontSize: '6rem'
  },
  errorText: {
    fontWeight: 'bold'
  }
}));

interface DefaultErrorProps {
  onReload?: () => void;
}

export const DefaultError: FC<DefaultErrorProps> = ({
  onReload
}: DefaultErrorProps) => {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      className={classes.container}
    >
      <TvOffOutlined className={classes.errorIcon} color="disabled" />
      <Typography
        className={classes.errorText}
        color="textSecondary"
        variant="h6"
        gutterBottom
      >
        Oops! Something went wrong!
      </Typography>
      <Button onClick={onReload} color="primary" size="large">
        RETRY
      </Button>
    </Grid>
  );
};

interface ViewStateContainerProps {
  state: ViewState;
  children?: ReactElement | null;
  okComponent?: ReactElement | null;
  errorComponent?: ReactElement | null;
  onReload?: () => void;
}

const ViewStateContainer: FC<ViewStateContainerProps> = ({
  state,
  children,
  okComponent,
  errorComponent,
  onReload
}: ViewStateContainerProps) => {
  const classes = useStyles();
  const childElement = isUndefined(children) ? null : children;
  const okElement = isUndefined(okComponent) ? null : okComponent;
  const errorElement = isUndefined(errorComponent) ? null : errorComponent;
  switch (state) {
    case ViewState.LOADING:
      return (
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.container}
        >
          <CircularProgress />
        </Grid>
      );
    case ViewState.ERROR:
      return isNull(errorElement) ? (
        <DefaultError onReload={onReload} />
      ) : (
        errorElement
      );
    case ViewState.OK:
      return isNull(okElement) ? childElement : okElement;
    default:
      return childElement;
  }
};

export default ViewStateContainer;
